<template>
  <header class="navbar-top">
    <span>出售明細</span>
  </header>

  <section class="content">
    <div class="table-responsive">
      <table class="table">
        <thead>
          <tr>
            <th scope="col">商品名稱</th>
            <th scope="col">角色名稱</th>
            <th scope="col">出售價格</th>
            <th scope="col">出售平台</th>
            <th scope="col">出售日期</th>
            <th scope="col">備註</th>
          </tr>
        </thead>
        <tbody>
          <td>第六彈饅頭</td>
          <td>敬人</td>
          <td>145</td>
          <td>露天</td>
          <td>2020/2/2</td>
          <td>自留友也、創、司、凜月、嵐</td>
        </tbody>
      </table>
    </div>
  </section>
  <footer class="footer"></footer>
</template>
